import { makeArray } from '../../../../../shared/utils';

type DimensionsEqualOptions = {
  ignoreOrder?: boolean;
};

export const areDimensionsEqual = (
  dimensionArray1: string[],
  dimensionArray2: string[],
  options: DimensionsEqualOptions = {}
) => {
  let arr1 = [...makeArray(dimensionArray1)];
  let arr2 = [...makeArray(dimensionArray2)];
  if (options.ignoreOrder) {
    arr1 = arr1.sort();
    arr2 = arr2.sort();
  }
  return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
};
